export default __webpack_public_path__ + "static/media/spin-bg-20.9f4a2acc.png";